import { useAuthContext } from './AuthContext';

export function useAuth() {
  return useAuthContext();
}

export function useRole() {
  const { user } = useAuthContext();
  return user?.role ?? null;
}

export function useIsOperator() {
  return useRole() === 'operator';
}
